import PropTypes from 'prop-types'
import React from 'react'

import Modal from 'components/Modal'

export const PasswordlessModal = (props) => <Modal
  isOpen={props.isOpen}
  contentLabel={`Sent you an email to login!`}
  onRequestClose={props.closeAction}
  title={`Sent Login Email`}
  buttons={[
    { text: 'Hide', options: ['red'], callback: props.closeAction }
  ]}
>
  <p>If the email is registered, we've sent a login link to <mark>{props.email}</mark>.</p>
</Modal>

PasswordlessModal.propTypes = {
  isOpen: PropTypes.bool,
  closeAction: PropTypes.func,
  successCallback: PropTypes.func,
  errorCallback: PropTypes.func,

  // for the url generation
  email: PropTypes.string,

  location: PropTypes.object,
  params: PropTypes.object
}

PasswordlessModal.defaultProps = {
  isOpen: false
}

export default PasswordlessModal



// WEBPACK FOOTER //
// ./src/containers/Modals/Passwordless/Passwordless.js